import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { UrlHelpers } from '../../service/UrlHelpers';
import { GdFreelancerStatus } from '../../typings/graphql-grid';
import { FreelancerBusyStatus } from '../FreelancerBusyStatus/FreelancerBusyStatus';
import * as FALLBACK_AVATAR from '../FreelancerCard/assets/FreelancerAvatar.svg';
import { RouteStyledLink } from '../StyledLink/StyledLink';
import { UserAvatar } from '../UserAvatar/UserAvatar';

import './FreelancerInfoCell.css';
import * as keyset from './FreelancerInfoCell.i18n';

export interface FreelancerInfoCellProps {
    isMyFreelancer: boolean;
    avatarLink?: string;
    avatarResize?: number;
    about?: string;
    fullName: string;
    status: GdFreelancerStatus;
    firstService: string;
    servicesCount: number;
    freelancerLogin: string;
    ulogin: string;
}

const i18n = i18nFactory(keyset);
const BLOCK = 'freelancer-info-cell';

export class FreelancerInfoCell extends React.PureComponent<FreelancerInfoCellProps> {
    render() {
        const {
            isMyFreelancer,
            avatarLink = String(FALLBACK_AVATAR),
            avatarResize,
            about = '',
            fullName,
            status
        } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                <RouteStyledLink cls={Bem.cls(BLOCK, 'avatar')} href={this.linkUrl}>
                    <UserAvatar resize={avatarResize} link={avatarLink} width={46} height={46} rounded={true} />
                </RouteStyledLink>

                <RouteStyledLink cls={Bem.cls(BLOCK, 'info')} href={this.linkUrl}>
                    <div className={Bem.cls(BLOCK, 'name')}>{fullName}</div>
                    <FreelancerBusyStatus
                        status={GdFreelancerStatus[status]}
                        isPageOwner={false}
                        isCooperating={isMyFreelancer}
                    />
                    <div className={Bem.cls(BLOCK, 'about')}>{about}</div>
                    <div className={Bem.cls(BLOCK, 'services')}>{this.renderServices()}</div>
                </RouteStyledLink>
            </div>
        );
    }

    private get linkUrl() {
        const { ulogin, freelancerLogin } = this.props;
        return UrlHelpers.getFreelancerCardUrl(ulogin, freelancerLogin);
    }

    private renderServices() {
        const { firstService, servicesCount } = this.props;

        return (
            <>
                <div className={Bem.cls(BLOCK, 'services-text')} title={firstService}>
                    {firstService}
                </div>
                {servicesCount > 0 ? (
                    <div className={Bem.cls(BLOCK, 'services-count')}>{`, ${i18n('more')} ${servicesCount}`}</div>
                ) : null}
            </>
        );
    }
}
